export type EndpointParamType = 'string' | 'boolean' | 'integer' | 'number' | 'array' | 'object';

export type EndpointParamEnvelope = 'request' | 'response';

export interface EndpointParam {
  name: string;
  in: string;
  envelope: EndpointParamEnvelope;
  type: EndpointParamType;
  required: boolean;
  description?: string;
  default?: unknown;
  enum?: unknown[];
  example?: unknown;
  resource?: string;
  surcharge_cents?: number;
  surcharge_group?: string;
}

export interface EndpointResponseSpec {
  type: string;
  schema: string;
  description?: string;
}

export interface EndpointDefinition {
  name: string;
  description?: string;
  method: string;
  path: string;
  /** Starting price for this endpoint, in cents same unit as each param's
   *  `surcharge_cents`, so total cost is just `credits_cents` plus
   *  whichever surcharges apply see estimateEndpointPrice() in
   *  playground/utils/endpoint-pricing.ts. Renamed server-side from a bare
   *  `credits` (a separate unit that needed the wallet's credits→cents
   *  rate to combine with surcharges). */
  credits_cents: number;
  focus?: boolean;
  response: EndpointResponseSpec;
  params: EndpointParam[];
}

export interface SchemaField {
  name: string;
  type: string;
  description?: string;
  schema?: string;
  items?: string;
  nullable?: boolean;
}

export interface SchemaDefinition {
  name: string;
  description?: string;
  fields: SchemaField[];
}

export interface EndpointCatalogResponse {
  endpoints: EndpointDefinition[];
  schemas: SchemaDefinition[];
  base_url: string;
}

export function getEndpointDefinition(
  catalog: EndpointCatalogResponse | null,
  name: string,
): EndpointDefinition | undefined {
  return catalog?.endpoints.find(e => e.name === name);
}
